import { Page } from "../types/wptypes";
import { Slide, AnimInfo, shape } from "../types/pgtypes";
import { Animation } from "./animation";
import { Util } from "./util";
import { PgReader } from "./pgreader";
declare global { var $: any }

export class AnimationContext {
  g: CanvasRenderingContext2D
  slide: Slide
  animInfo: AnimInfo
  count: number
  shape: shape
  reset(slide: Slide, g: CanvasRenderingContext2D, animInfo?: AnimInfo) {
    this.g = g;
    this.slide = slide;
    this.count = 0;
    this.animInfo = animInfo;
    this.shape = animInfo.shape
  }
}


export class AnimationManager {
  public static instance: AnimationManager = new AnimationManager()

  private animCanvas: HTMLCanvasElement

  private player: Animation = new Animation();
  private animationContext: AnimationContext

  private page: Slide
  private animations: AnimInfo[][]
  private allAnimationCompleted: boolean
  public currentAnimIndex: number
  public delayAnimateId: number
  public gotoAimationPageIndex: number
  public gotoAimationType: string

  public beginPage(page: Slide, isdispath?: boolean) {
    this.page = page;
    this.animations = page.animation;
    this.allAnimationCompleted = this.animations ? false : true;
    this.currentAnimIndex = 0;
    this.gotoAimationPageIndex = page.index;
    //清空page上面animation对象的状态
    if (!page.animation) return
    for (let animateArray of page.animation) {
      for (let animate of animateArray) {
        animate.animationState = 0
      }
    }
    // 当第一帧动画为startCondition === 1的时候，为提前播放的动画
    if (this.animations.length) {
      if (this.animations[0][0].startCondition === 1 || this.animations && this.animations[0][0].startCondition === 2) {
        if (isdispath) {
          this.next(isdispath);
        } else {
          this.next();
        }
      }
    }
  }

  public preBeginPage(page: Slide) {
    this.page = page;
    this.animations = page.animation;
    this.allAnimationCompleted = this.animations ? false : true;
    this.currentAnimIndex = 0;
    this.gotoAimationPageIndex = page.index;
    //清空page上面animation对象的状态
    for (let animateArray of page.animation) {
      for (let animate of animateArray) {
        animate.animationState = 2
      }
    }
  }


  private isPreAnimate: boolean = true // 判断当前播放的动画是否为提前播放的动画
  private sametimeData: AnimationContext[] = [] // 当前动画数据
  private isEffectAfterPlay: boolean // 灯片最后一个动画（设置为下次单机后隐藏，结束单机鼠标后不能直接跳转至下张幻灯片
  /** 
   * true:表示还是动画，false：表示当前slide没有或者已经播完所有动画 
   * */

  public oneSameTimeAimations: AnimationContext[] // 记录最新的一个obj有同时动画的数据，可以在任何地方调用
  public next(isdispath?: boolean) {
    this.gotoAimationType = 'next';
    // 当上一个动画未执行完，又点击了下一个动画的时候，直接将上次动画绘制到最后一帧  fix判断条件错误 2021.11.4 
    if (this.sametimeData && this.sametimeData.find(v => v.animInfo.animationState === 1)) {
      this.play(true);
    }
    this.sametimeData = [];
    let list = this.animations || [];
    let page = this.page,
      infoArray = list[this.currentAnimIndex];
    if (!list || !list.length || this.currentAnimIndex >= list.length) {
      // 最后一帧播放的时候，不是立即执行下一页的动画，而是提前播放完最后一帧，停留在当前页面
      if (this.allAnimationCompleted || (!this.isPreAnimate && !this.isEffectAfterPlay) || list.length === 0) {
        let pageIndex = Number(PgReader.instance.startPageIndex) + 1
        if (pageIndex < PgReader.instance.doc.pages.length) {
          this.beginPage(PgReader.instance.doc.pages[pageIndex] as Slide)
          PgReader.instance.gotoPage(pageIndex)
        } else {
          // 给人教的定制版本直接没有黑框的
          // 目前是给屏幕加一个黑屏，单击退出播放
          // if (!$('#blackCover').hasClass('hiden')) {
          //     $('#blackCover').addClass('hiden')
          //     PgReader.instance.setFullScreen(false)
          //     return false
          // }
          // $('#blackCover').removeClass('hiden')
          // 当为自动播放状态的时候，执行循环播放,目前 delay
          // if (PgReader.instance.autoAimatePlay) {
          //     this.beginPage(PgReader.instance.doc.pages[0] as Slide)
          //     PgReader.instance.gotoPage(0)
          //     setTimeout(() => {
          //         this.next()
          //     }, PgReader.instance.autoAimatePlayTime);
          // }
          return false
        }
      } else {
        this.allAnimationCompleted = true
      }
      // 判断下最后一个动画是否是同一个动画
      // PgReader.instance.paint(false, this.sametimeData);
      PgReader.instance.paint(false, this.oneSameTimeAimations);
      return false
    }
    this.isPreAnimate = true
    // 音频文件类似的animationState状态已经是2了,遇到已经播放完的动画直接播放下一帧动画
    for (let info of infoArray) {
      // if (info.animationState === 2) {
      //     this.currentAnimIndex++;
      //     this.next();
      //     return true;
      // }
      // 点击过后，需要播放的动画animationState状态置成1
      info.animationState = 1;
      let content = new AnimationContext();
      content.reset(page, PgReader.instance.g, info);
      this.sametimeData.push(content);
      // 检测这个动画是否是强调类型的动画，如果是的话，需要保存content的内容
      if (info.animType === 1 || info.animType === 3) {
        info.stressContent = content
      }
      // 灯片最后一个动画（设置为下次单机后隐藏，结束单机鼠标后不能直接跳转至下张幻灯片
      if (this.currentAnimIndex == list.length - 1 && info.effectAfterPlay === 4) {
        this.isEffectAfterPlay = true
      } else {
        this.isEffectAfterPlay = false
      }
    }
    // 记录最新的一个obj有同时动画的数据，可以在任何地方调用
    this.oneSameTimeAimations = this.sametimeData;
    // 有延时的情况的话，需要延迟处理
    let delayTime = (Number(infoArray[0].startTime) || 0) * 1000
    this.delayAnimateId = window.setTimeout(() => {
      this.play()
    }, delayTime);

    // 派发跳转数据
    this.currentAnimIndex++
    return true;
  }

  public pre(isdispath?: boolean) {
    this.gotoAimationType = 'pre';
    // 如果当前是屏幕黑屏状态的时候，向上一个状态便是去除黑屏
    // if (!$('#blackCover').hasClass('hiden')) {
    //     $('#blackCover').addClass('hiden')
    //     return
    // }
    // 动画翻页的问题，遇到this.currentAnimIndex === 0的情况，动画往上翻页
    if (this.currentAnimIndex === 0) {
      let pageIndex = Number(PgReader.instance.startPageIndex) - 1
      if (pageIndex === -1) return
      this.preBeginPage(PgReader.instance.doc.pages[pageIndex] as Slide)
      // 每次绘制传入动画数据，这样方便绘制最后一秒的样子
      this.oneSameTimeAimations = []
      let allList = this.animations
      let page = this.page, allInfoArray = (this.currentAnimIndex === 0 ? allList[allList.length - 1] : allList[this.currentAnimIndex - 1]) || []
      for (let info of allInfoArray) {
        let content = new AnimationContext();
        content.reset(page, PgReader.instance.g, info);
        this.oneSameTimeAimations.push(content);
      }
      PgReader.instance.gotoPage(pageIndex, this.oneSameTimeAimations)
      this.currentAnimIndex = this.animations.length
      return
    }
    this.currentAnimIndex--
    let list = this.animations
    let infoArray = list[this.currentAnimIndex]
    for (let info of infoArray) {
      info.animationState = 0
      // 针对一个对象会有多个动画的数据，譬如青蛙跳，也需要将数据重置
      if (info.shapeSameAnimation) {
        info.shapeSameAnimation = 1;
        info.stressContent = undefined;
      }
      if (info.groupSameAnimation) {
        info.groupSameAnimation = 1;
      }
    }
    // 每次绘制传入动画数据，这样方便绘制最后一秒的样子
    this.oneSameTimeAimations = []
    let allList = this.animations
    let page = this.page, allInfoArray = this.currentAnimIndex === 0 ? allList[allList.length - 1] : allList[this.currentAnimIndex - 1]
    for (let info of allInfoArray) {
      let content = new AnimationContext();
      content.reset(page, PgReader.instance.g, info);
      this.oneSameTimeAimations.push(content);
    }
    // 为了之前之后动画类型设计
    if (infoArray[0].startCondition === 2 && this.currentAnimIndex !== 0) {
      this.pre();
      return;
    }
    // 每次向上滚动后，然后再次向下滚动的时候，因为每次都需要先进入提前播放状态，解决BUGDCC-4844
    this.sametimeData = undefined;
    // 向上翻页的时候，所有动画就变成没有全部播放完了
    this.allAnimationCompleted = false
    // 逻辑执行完可以绘制
    PgReader.instance.paint(false, this.oneSameTimeAimations)
  }

  public gotoAnimation(animateObj: any) {
    let pageIndex = animateObj.pageIndex
    let animationId = animateObj.animationId
    let type = animateObj.type
    this.beginPage(PgReader.instance.doc.pages[pageIndex] as Slide, true)
    PgReader.instance.gotoPage(pageIndex)
    let page = this.page
    // 将当前播放的动画数据显示播放完成
    let list = this.animations
    for (let i = 0; i < animationId; i++) {
      let infoArray = list[i];
      for (let info of infoArray) {
        info.animationState = 2
        // 检测这个动画是否是强调类型或者自定义数据类型的动画，如果是的话，需要保存content的内容
        if (info.animType === 1 || info.animType === 3) {
          let content = new AnimationContext();
          content.reset(page, PgReader.instance.g, info);
          info.stressContent = content
        }
      }
    }

    // if (type === 'next') {
    //     this.currentAnimIndex = animationId
    //     if (animationId >= list.length) {
    //         this.allAnimationCompleted = true
    //     }
    //     this.next(true)
    // } else if (type === 'pre') {
    //     this.currentAnimIndex = animationId
    //     this.pre(true)
    // }
  }

  private isSamePlayContine: boolean // 动画是否能播放，因为同时进行的动画可能持续时间不一致
  private stopPreAnimate: number
  private play(preAnimationEnd?: boolean) {
    if (!this.sametimeData || this.sametimeData.length === 0) return;
    if (preAnimationEnd) { // 动画提前播放完成
      for (let i = 0; i < this.sametimeData.length; i++) {
        let c = this.sametimeData[i], info = c.animInfo;
        info.animationState = 2;
        // 针对一个对象会有多个动画的数据，譬如青蛙跳，需要单独加个标志，以区分这类数据 1:代表未播放 2:代表播放完毕
        if (info.shapeSameAnimation) {
          info.shapeSameAnimation = 2;
        }
        if (info.groupSameAnimation) {
          info.groupSameAnimation = 2;
        }
      }
      cancelAnimationFrame(this.stopPreAnimate)
      PgReader.instance.paint(false, this.sametimeData);
      return;
    }

    this.isSamePlayContine = false
    for (let i = 0; i < this.sametimeData.length; i++) {
      let c = this.sametimeData[i], info = c.animInfo, endCount = Math.ceil(info.endTime * 60)
      // 降帧绘制，预计24帧1s绘制,绘制最后一帧丢失（解决BUG:DCC-6225）
      if (c.count === 0 || c.count % 3 === 0 || c.count % 13 === 0 || c.count === endCount) {
        PgReader.instance.paint(false, this.sametimeData);
      }
      // 不降帧绘制
      // PgReader.instance.paint(false, this.sametimeData);
      c.count++
      if (c.count > endCount) {
        info.animationState = 2
        // 针对一个对象会有多个动画的数据，譬如青蛙跳，需要单独加个标志，以区分这类数据 1:代表未播放 2:代表播放完毕
        if (info.shapeSameAnimation) {
          info.shapeSameAnimation = 2;
        }
        if (info.groupSameAnimation) {
          info.groupSameAnimation = 2;
        }
      } else {
        this.isSamePlayContine = true
      }
    }
    if (this.isSamePlayContine) {
      this.stopPreAnimate = requestAnimationFrame(() => {
        this.play()
      })
    } else {
      this.isPreAnimate = false
      console.log('sameAnimation is compalte')
      // 当后面一个动画类型为之后播放的动画的时候，需要继续播放下一帧动画
      if (this.animations[this.currentAnimIndex]) {
        if (this.animations[this.currentAnimIndex][0].startCondition === 2) this.next();
      }
      // 动画播放完后，设置为播放动画后隐藏时，只需要重新绘制一下即可
      if (this.animations[this.currentAnimIndex - 1]) {
        if (this.animations[this.currentAnimIndex - 1][0].effectAfterPlay === 3) {
          // 设置延时是为了出现的动画类型设置的，bug号：1385
          setTimeout(() => {
            PgReader.instance.paint();
          }, 200);
        }
      }
    }
  }
}